import React from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { FileText } from 'lucide-react';

import termsMd from '../content/terms.md?raw';

export const TermsPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <div className="inline-flex items-center space-x-3 mb-6">
          <div className="p-4 rounded-xl bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-sm border border-green-300/50 shadow-sm">
            <FileText className="w-10 h-10 text-blue-700" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-black">Terms of Use</h2>
        </div>
        <p className="text-gray-700 text-lg max-w-2xl mx-auto">
          Terms and conditions for using CommsGenie services
        </p>
      </div>

      <div className="backdrop-blur-xl bg-white/90 border border-green-300/50 rounded-2xl p-8 shadow-lg">
        <div className="prose prose-lg max-w-none">
          <ReactMarkdown
            components={{
              a: ({ href, children, ...props }) => {
                const url = href ?? '';

                if (url.startsWith('/')) {
                  return (
                    <Link
                      to={url}
                      className="text-green-700 hover:text-green-900 underline transition-colors"
                    >
                      {children}
                    </Link>
                  );
                }

                return (
                  <a
                    href={url}
                    {...props}
                    className="text-green-700 hover:text-green-900 underline transition-colors"
                  >
                    {children}
                  </a>
                );
              },
            }}
          >
            {termsMd}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};


